import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Lock, Mail, LogIn } from 'lucide-react';

export default function LoginPage({ onLogin }) {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await onLogin(email, password);
    setLoading(false);
    if (result.ok) {
      navigate(from, { replace: true });
      return;
    }
    setError(result.error || 'Falha no login.');
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-loginPage">
      <div className="w-full max-w-sm">
        <div className="bg-loginCard rounded-2xl shadow-2xl border border-loginCardBorder overflow-hidden">
          <div className="px-8 pt-10 pb-2 text-center">
            <div className="flex justify-center mb-4">
              <img
                src="/logo-unipapo.png"
                alt="Unipapo"
                className="h-10 w-auto object-contain"
              />
            </div>
          </div>

          <form onSubmit={handleSubmit} className="px-8 pb-8 pt-4">
            {error && (
              <div className="mb-4 py-2.5 px-3 rounded-lg bg-loginErrorBg text-loginErrorText text-sm border border-loginErrorBorder">
                {error}
              </div>
            )}

            <label className="block text-sm font-medium text-loginLabel mb-1.5">E-mail</label>
            <div className="relative mb-4">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-loginInputPlaceholder" size={18} />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-loginInputBorder bg-loginInputBg text-white placeholder:text-loginInputPlaceholder focus:outline-none focus:ring-2 focus:ring-loginInputFocus focus:border-loginInputFocus transition"
                required
                autoComplete="email"
              />
            </div>

            <label className="block text-sm font-medium text-loginLabel mb-1.5">Senha</label>
            <div className="relative mb-6">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-loginInputPlaceholder" size={18} />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-loginInputBorder bg-loginInputBg text-white placeholder:text-loginInputPlaceholder focus:outline-none focus:ring-2 focus:ring-loginInputFocus focus:border-loginInputFocus transition"
                required
                autoComplete="current-password"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg bg-loginButton text-white font-semibold hover:bg-loginButtonHover focus:outline-none focus:ring-2 focus:ring-neutral-600 focus:ring-offset-2 focus:ring-offset-loginCard disabled:opacity-60 disabled:cursor-not-allowed transition"
            >
              {loading ? (
                <span className="animate-pulse">Entrando...</span>
              ) : (
                <>
                  <LogIn size={18} />
                  Entrar
                </>
              )}
            </button>
          </form>
        </div>

        <p className="text-center text-loginFooter text-xs mt-6">
          Após rodar o seed: contato@brunnoalves.com.br
        </p>
      </div>
    </div>
  );
}
